'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Layer = require('./Layer');

var _Layer2 = _interopRequireDefault(_Layer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Parallax = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Parallax, _React$Component);

  function Parallax(props) {
    (0, _classCallCheck3.default)(this, Parallax);
    return (0, _possibleConstructorReturn3.default)(this, (Parallax.__proto__ || (0, _getPrototypeOf2.default)(Parallax)).call(this, props));
  }

  (0, _createClass3.default)(Parallax, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //https://github.com/wagerfield/parallax
      var self = this;
      $.getScript("/" + self.context.project + "/lib/jquery.parallax.js", function () {
        $('#scene').parallax();
      }.bind(this));
    }
  }, {
    key: 'render',
    value: function render() {
      var txt = this.props.content;

      return _react2.default.createElement(
        'div',
        { id: 'scene', className: "scene " + this.props.parallaxClass },
        this.props.content.map(function (layer, i) {
          return _react2.default.createElement(_Layer2.default, { key: i, layer: layer });
        })
      );
    }
  }]);
  return Parallax;
}(_react2.default.Component), _class.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired
}, _temp);
exports.default = Parallax;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Parallax/Parallax.js
// module id = 802
// module chunks = 0